import { z } from 'zod';

import { REPROCESSING_INVOICE_PROCESS_STATUS } from './constants';

export const zodReprocessingInvoiceProcessStatusSchema = z.enum(
  REPROCESSING_INVOICE_PROCESS_STATUS,
);

export const zodReprocessingInvoiceProcessStatusResponseSchema = z.object({
  status: zodReprocessingInvoiceProcessStatusSchema,
});

export const zodReprocessingInvoiceProcessStatusEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.literal('process'),
  z.uuid(),
  z.literal('status'),
]);
